import { topliApi } from '@/shared/api/topli/TopliApi'
import { useQuery } from '@tanstack/react-query'
import { AgentActionsRequestParams } from './model/types'
export const agentActionsByPageQueryKey = 'agentActionsByPage'

export const fetchAgentActionsByPage = async (
  sorting: string | null,
  limit: number,
  offset: number,
  search: string,
  actions?: number[],
  user_id?: number,
) => {
  const requestParams: AgentActionsRequestParams = {
    limit,
    offset,
    sort: sorting,
    user__fullname__icontains: search,
  }

  if (actions?.length) {
    requestParams.action__in = actions
  }

  if (user_id) {
    requestParams.user_id = user_id
  }

  const response = await topliApi.agentActions.list(requestParams)
  return response
}

export const useAgentActionsByPage = (
  sorting: string | null,
  limit: number,
  page: number,
  search: string,
  actions: number[],
  user_id?: number,
) =>
  useQuery({
    queryKey: [agentActionsByPageQueryKey, sorting, page, limit, search || '', actions, user_id],
    queryFn: () => fetchAgentActionsByPage(sorting, limit, page, search, actions, user_id),
  })
